import { useState } from "react";
import { FaBookmark, FaRegBookmark } from "react-icons/fa";
import { editarSolicitante } from "../../services/apis_funcionarios";

// Componente Flag que muestra un icono de marcador basado en el estado del atributo 'flag' del solicitante
// Recibe 'flag' (booleano) y 'size' (tamaño del icono) como props
// Al presionarlo envía una request para alternar el estado del marcador en la base de datos

const styles = {
  toggle: {
    cursor: "pointer",
    transition: "opacity 0.2s ease, transform 0.1s ease",
  },
  flagActive: { color: "var(--color-accent)" },
  flagInactive: { color: "var(--color-gray)" },
};

function Flag({ idSolicitante, initialFlag = false, onChange, size = 30 }) {
  const [flag, setFlag] = useState(initialFlag);
  const [loading, setLoading] = useState(false);

  const toggleFlag = async () => {
    if (loading) return;
    setLoading(true);

    const nuevoValor = !flag;

    try {
      await editarSolicitante(idSolicitante, { flag: nuevoValor });
      setFlag(nuevoValor);
      if (onChange) onChange(nuevoValor);
    } catch (err) {
      console.error("Error al actualizar flag:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <span
      onClick={toggleFlag}
      title={flag ? "Quitar marcador" : "Marcar solicitante"}
      style={{
        ...styles.toggle,
        opacity: loading ? 0.6 : 1,
        pointerEvents: loading ? "none" : "auto",
      }}
    >
      {flag ? (
        <FaBookmark size={size} style={styles.flagActive} />
      ) : (
        <FaRegBookmark size={size} style={styles.flagInactive} />
      )}
    </span>
  );
}

export default Flag;
